import { ChevronRight } from "lucide-react";
import { fmtUSD } from "@/lib/format";
import { jumpLabel } from "@/components/leaderboard/climbTargets";

export default function RankTargetButton({ target, active, onHover, onSelect, floating = false }) {
  const jump = jumpLabel(target.positions_gained);
  const price = fmtUSD(target.amount_usd);
  return (
    <button
      type="button"
      data-testid={`rank-target-${target.target_rank}`}
      aria-pressed={active}
      aria-haspopup="dialog"
      aria-label={`Take rank ${target.target_rank} for ${price}. ${jump}.`}
      onMouseEnter={() => onHover(target)}
      onMouseLeave={() => onHover(null)}
      onFocus={() => onHover(target)}
      onBlur={() => onHover(null)}
      onClick={(event) => {
        event.stopPropagation();
        onSelect(target);
      }}
      className={floating
        ? `climb-target-card flex min-w-[148px] items-center justify-between gap-3 rounded-xl border px-3 py-2 text-left ${
          active ? "border-cyan-200 bg-cyan-400/15" : "border-cyan-300/40 bg-[#071018]/90"
        }`
        : `flex w-full items-center justify-between gap-3 rounded-xl border px-3 py-2 text-left ${
          active ? "border-cyan-300/80 bg-cyan-400/10" : "border-white/10 bg-white/[0.03] hover:border-cyan-300/50"
        }`}
    >
      <span>
        <span className="block font-display text-sm font-black tracking-tight text-white">
          Take #{target.target_rank} <span className="text-cyan-200">{price}</span>
        </span>
        <span className="block text-[11px] text-zinc-400">{jump}</span>
      </span>
      {floating && <ChevronRight className="h-4 w-4 shrink-0 text-cyan-200" strokeWidth={2} />}
    </button>
  );
}
